
/**
 * ContextMenu
 * @param  {} elementId
 * @param  {} items  Instance receive 2 objects items [{}] array a list of menu items {text,cssClass,onClick} 
 * @param  {} options 
 * @example 
 * var mEnrolleesMapMenuItems = [{ 
 *      text:'Create Enrollee Address',
 *      cssClass:'contextMenuClass-item',
 *      OnClick: function (latLng){  }
 * }];
 * veritracks.enrollees.mapping.contextMenu = new ContextMenu('uMapOffenderContextMenu',mEnrolleesMapMenuItems,{
 *  class:'contextMenuClass'
 * });
 */
var ContextMenu = (function(){
    /*  Instance	 */

    return function Menu(elementId,items,options){
        this.elementId = elementId ? elementId :'menu';
        this.items = items ? items : [];
        this.options = options ? options : {class:'contextMenuClass'};
        this.menuDisplayed = false;
        this.latLng = null;
        this.data = null;
        this.element = document.getElementById(this.elementId)
        if(this.element === null || typeof this.element === "undefined"){
            this.element = document.createElement('div');
            this.element.id = this.elementId;
            document.body.appendChild(this.element);
        }
        this.element.className = this.options['class']? this.options['class'] : 'contextMenuClass';
        function onMouseOut(event) {           
            var e = event.toElement || event.relatedTarget;
            //check for all children levels (checking from bottom up)
            while(e && e.parentNode && e.parentNode != window) {
                if (e.parentNode == this.element||  e == this.element) {
                    if(e.preventDefault) e.preventDefault();
                    return false;
                }
                e = e.parentNode;
            }
            this.hideMenuNoEvent();
        }
        /**
         * .show(e) function that renders
         * @param {MouseEvent} e - MouseEvent that includes clientX, clientY
         */
        this.show = function(e,data,ids){
            if(e.latLng){
                this.latLng = e.latLng;
            }
            if(data){
                this.data = data;
            }
            if(!e){
                console.warn('e -> click event missing to display menu')
            }
            if(this.isCurrentModalOpen()){
                return;
            }
            //position
            var mouseEvt = null;
            for (var prop in e) {
                if (e[prop] instanceof MouseEvent) {
                    mouseEvt = e[prop];
                }
            }
            if (!mouseEvt){
                mouseEvt = {
                    "clientX": e['position'].x,
                    "clientY": e['position'].y,
                    "preventDefault": function(){}
                };
            }
            if(mouseEvt){
                var left = mouseEvt.clientX;
                var top = mouseEvt.clientY;
                this.element.style.left = left + "px";
                this.element.style.top = top + "px";
                this.element.style.display = "block";
                this.renderMenu(this.elementId,ids);
                mouseEvt.preventDefault();
                this.menuDisplayed = true;
            }
            this.element.addEventListener("mouseout", onMouseOut.bind(this), false);

        }
        this.hideMenuNoEvent = function hideMenuNoEvent(){
            if (this.menuDisplayed == true) {
                this.element.style.display = "none";
                this.menuDisplayed = false;
            }
            this.element.removeEventListener("mouseout", onMouseOut, false);
        }
        /**
         * .hide(e) function that renders
         * @param {MouseEvent} e - MouseEvent that includes clientX, clientY
         */
        this.hide = function(e){
            this.hideMenuNoEvent();
            if(e){
                for (var prop in e) {
                    if (e[prop] instanceof MouseEvent) {
                        e[prop].preventDefault();// mousePrevent
                    }
                }
            }
        }
        /**
         * .renderMenu('elementId') function that renders
         * @param {string} elementId - id="elementId" name of the element id
         * @return {string} A good string
         *
         * @example
         *     renderMenu('elementId')
         */
        this.renderMenu  = function (elementId,ids){
            // render any element an html
            /* var div = document.getElementById(this.elementId);
            this.element.class = this.options['class']; */
            if(!this.element){
                console.warn('calling render@fn without mapMenu element',this.element);
                return;
            }      
            var lHtml =[];
            ids = ids && Array.isArray(ids) ? ids: [];
            this.element.innerHTML = "";
            for(var i = 0; i < this.items.length; i++){
                if(ids && ids.includes(i)){
                    this.element.appendChild(this.itemHtml(this.items[i]));
                }else if (ids.length === 0){
                    this.element.appendChild(this.itemHtml(this.items[i]));
                }
            }
        }
        /**
         * checkIfModalsAreOpen() checks current modals and checks if is Open
         * @return boolean 
         */
        this.isCurrentModalOpen = function (){
            var modalIds = ['uVeritracksCustomPopup','uVeritracksModal'];
            var result = false;
            for(var key in modalIds){
                var elm = document.getElementById(modalIds[key]);
                if(elm !== null){
                    if(elm.style.display  === "block"){
                        result = true;
                        break;
                    }
                }
            }
            return result;
        }
        /**
         * getItems() get menu item list 
         * @return list of items []
         */
        this.getItems = function (){
            return this.items;
        }
        /**
         * addItem function add an Item to the menu
         * @param {object} item - Object that includes {text,cssClass,OnClick}
         */
        this.addItem = function(item){
            this.items.push(item)
            this.renderMenu(this.elementId)
        }
        /**
         * removeItem function remove Item from the menu
         * @param number index - Index from the list of items.
         */
        this.removeItem = function(index){
            this.items.splice(index,1);
            this.renderMenu(this.elementId)
        }
        /**
         * itemHtml function get item HTML for menu
         * @param {object} item - Object that includes {text,cssClass,OnClick}
         * @return  html node Object .appendChild(node*) 
         */
        this.itemHtml  = function(item){
        /* var htmlObj=[] */
            if(!item || item == {}){
                console.warn('Missing item');
                return;
            }
            var _this  = this;
            var latLng = this.latLng, d = this.data;
            var elm = document.createElement('div');
            elm.className = item['cssClass'];
            elm.onclick = function(){
                _this.hide();
                item['OnClick'](latLng,d);
            };
            elm.appendChild(document.createTextNode(item['text']));
            return elm;// htmlObj.join(' ').toString();
        }
    }
    
})();
if (typeof exports !== 'undefined') {
    module.exports = ContextMenu;
}